// extracted by mini-css-extract-plugin
module.exports = {"wrap":"ContactPage_wrap__2lS97","title":"ContactPage_title__3Ef4Q","subtitle":"ContactPage_subtitle__30rCH"};